<template>
		<div class="container-fluid">
		<div class="row">
			<div class="offset-xl-3 col-xl-6 offset-md-2 col-md-8 account">
				<div class="row header">
					<div class="col-12">
						<h1>Support</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<hr>
					</div>
				</div>
				<Form />
			</div>
		</div>
	</div>
</template>

<script>
import Form from '../Support/Form';

export default {
 components: {
	 Form
 }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Pages/Support.vue